import { useQuery } from 'data-fetching-client';
import { getI18nLangLocale } from 'pricing-pages-lib/utils/languageUtils';
import { GET_PRIORITY_FEATURES_QUERY } from '../../../../__generated__/chirp/com/hubspot/feature/store/rpc/PriorityFeaturesRpc.dfc.new';
const usePriorityFeaturesForApiName = ({
  productApiName
}) => {
  const langLocale = getI18nLangLocale();
  const {
    data,
    loading
  } = useQuery(GET_PRIORITY_FEATURES_QUERY, {
    variables: {
      productApiName: productApiName !== null && productApiName !== void 0 ? productApiName : '',
      i18nLangLocale: langLocale
    },
    skip: !productApiName
  });
  return {
    priorityFeatures: (data === null || data === void 0 ? void 0 : data.result.priorityFeatures) || [],
    loading
  };
};
export const useCategorizedPriorityFeatures = ({
  productApiName
}) => {
  const {
    loading,
    priorityFeatures: features
  } = usePriorityFeaturesForApiName({
    productApiName
  });
  const brandingAndLimitFeatures = features.filter(feature => feature.featureType === 'LIMIT_INCREASE' || feature.featureType === 'REMOVE_BRANDING');
  const uncategorizedFeatures = features.filter(feature => !feature.featureType);
  return {
    loading,
    brandingAndLimitFeatures,
    uncategorizedFeatures
  };
};